import React from 'react';
import './Contact.css';
import { useLanguage } from '../context/LanguageContext';

const Contact = () => {
  const { t } = useLanguage();

  return (
    <div className="contact" id="contact">
      <div className="contact-container">
        <div className="contact-intro">
          <p className="contact-subtitle">{t('contact.subtitle')}</p>
          <h2 className="contact-title">{t('contact.title')}</h2>
        </div>
        
        <div className="contact-form-section">
          <h2 className="form-title">{t('contact.formTitle')}</h2>
          
          <form className="contact-form">
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="name">{t('contact.formLabels.name')}</label>
                <input type="text" id="name" name="name" required />
              </div>
              
              <div className="form-group">
                <label htmlFor="phone">{t('contact.formLabels.phone')}</label>
                <input type="tel" id="phone" name="phone" />
              </div>
            </div>
            
            <div className="form-group full-width">
              <label htmlFor="email">{t('contact.formLabels.email')}</label>
              <input type="email" id="email" name="email" required />
            </div>
            
            <div className="form-group full-width">
              <label htmlFor="instagram">{t('contact.formLabels.instagram')}</label>
              <div className="instagram-input">
                <span className="instagram-at">@</span>
                <input type="text" id="instagram" name="instagram" />
              </div>
            </div>
            
            <div className="form-group full-width">
              <label htmlFor="message">{t('contact.formLabels.message')}</label>
              <textarea id="message" name="message" rows="4" required></textarea>
            </div>
            
            <button type="submit" className="submit-button">
              {t('contact.submitButton')}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact; 